"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NucleusGroup = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const IsotopesViewer_1 = __importDefault(require("../../../elements/IsotopesViewer"));
const styles = {
    groupContainer: {
        padding: '5px',
        borderRadius: '5px',
        margin: '10px 0px',
        backgroundColor: 'white',
    },
    header: {
        borderBottom: '1px solid #e8e8e8',
        paddingBottom: '5px',
        fontWeight: 'bold',
        color: '#4a4a4a',
    },
};
function NucleusGroup({ nucleus, children, renderTop, renderBottom, }) {
    return ((0, jsx_runtime_1.jsxs)("div", { style: styles.groupContainer, children: [(0, jsx_runtime_1.jsx)(IsotopesViewer_1.default, { style: styles.header, value: nucleus }), renderTop?.(), children, renderBottom?.()] }, nucleus));
}
exports.NucleusGroup = NucleusGroup;
